<template>
  <transition name="fade">
    <div class="backdrop">
      <article class="modal">
        <header class="modal-header">
          <h3 class="heading">
            {{ $t(heading) }}
          </h3>
          <button
            class="btn__icon"
            @click="close"
          >
            <Icon
              name="close"
              :fills="['#000', 'none']"
            />
          </button>
        </header>
        <section class="modal-body">
          <p
            class="copy bold"
            v-if="subject"
            v-html="$t(subject)"
          />
          <slot name="modal-actions" />
        </section>
        <footer class="modal-footer">
          <slot name="modal-buttons" />
        </footer>
      </article>
    </div>
  </transition>
</template>

<script>
import Icon from "./Icon.vue";

export default {
  name: "Modal",
  components: {
    Icon,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    subject: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
